module.exports = __webpack_public_path__ + "img/valance-switch-hover.97384c7c.png";